import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
import { useEoaAccount } from "../useEoaAccount";
// import { useWeb3React } from "@web3-react/core";

const CurrentPrice = () => {
    const { account } = useEoaAccount();
    const web3 = useWeb3();
    const CurrentPriceHook = useCallback(
        async (address, choiceIndex) => {
            const contract = getTrade(address, web3);
            try {
                const amountdata = await contract.methods.getCurrentPrice(choiceIndex).call();
                return amountdata;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3, account]
    );
    return CurrentPriceHook;
};

export default CurrentPrice;